// tslint:disable-next-line:eofline
export * from './home.component';
